import { render } from "./UtilizatoriAdmin.vue?vue&type=template&id=d08c0816"
import script from "./UtilizatoriAdmin.vue?vue&type=script&lang=js"
export * from "./UtilizatoriAdmin.vue?vue&type=script&lang=js"

import "./UtilizatoriAdmin.vue?vue&type=style&index=0&id=d08c0816&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__